import type { ReactNode } from "react";
import { FormatterMode } from "@textformatter/formatter";
import { cn } from "@/lib/utils";
import { ALL_FORMAT_SLUG_EXAMPLES } from "@/data/formatterAllExamples";
import type { FormatterMode as FormatterModeType } from "@/components/formatter/types";

type ExamplesPageLayoutProps = {
	children: ReactNode;
	className?: string;
	width?: "3xl" | "6xl";
	paddingY?: "6" | "8";
};

export default function ExamplesPageLayout({
	children,
	className,
	width = "6xl",
	paddingY = "6",
}: ExamplesPageLayoutProps) {
	const widthClass = width === "3xl" ? "max-w-3xl" : "max-w-6xl";
	const paddingYClass = paddingY === "8" ? "py-8" : "py-6";
	const sectionOrder: { contentType: FormatterModeType; title: string }[] = [
		{ contentType: FormatterMode.Text, title: "Plain Text" },
		{ contentType: FormatterMode.Web, title: "Web" },
		{ contentType: FormatterMode.Ecommerce, title: "Ecommerce" },
	];

	return (
		<main className={cn("mx-auto flex flex-col gap-6 px-6", widthClass, paddingYClass, className)}>
			{children}
			<div className="mt-2 border-t border-gray-300 pt-6 text-sm text-muted-foreground">
				<div className="grid grid-cols-1 gap-6 sm:grid-cols-3 lg:grid-cols-3">
					{sectionOrder.map((section) => {
						const sectionExamples = ALL_FORMAT_SLUG_EXAMPLES.filter(
							(example) => example.contentType === section.contentType,
						);
						return (
							<div key={section.contentType}>
								<p className="mb-2 text-[1rem] font-medium text-foreground">{section.title}</p>
								<div className="flex flex-col items-start gap-1">
									{sectionExamples.map((example) => (
										<a
											key={example.id}
											href={`/format/${example.slug}`}
											className="inline-block text-[0.8rem] hover:underline"
										>
											{example.label}
										</a>
									))}
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</main>
	);
}
